import script from "./UserInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=311eefa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-311eefa8"]])

export default __exports__